import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {deleteCalendarView as deleteCalendarViewAPI} from '../../../services/calendarViews'

export async function deleteCalendarView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await deleteCalendarViewAPI(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Delete Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
